const apiUrl = process.env.REACT_APP_BASE_URL

export default apiUrl;
